(function () {
  var FORM_ID = "_rsi-cod-form-modal-form";
  var ENDPOINT = "https://api-new.3alla9ni.net/webhook/shopify/quick-form-abandoned";

  var hasSubmitted = false; // si le form a été soumis => stop

  // ✅ IMPORTANT: dédup par "clé" (shop+cart+phone)
  // -> si tu changes le téléphone, ça renvoie (1 seule fois par tel/panier)
  var sentKeys = {}; // dédup session/page

  // ✅ Anti-doublon persistant (même si reopen modal / reload page)
  var LS_PREFIX = "__RSI_ABANDON_SENT__";
  function safeLSGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function safeLSSet(key, val) {
    try { window.localStorage.setItem(key, val); } catch (e) {}
  }

  function getShopifyDomain() {
    try {
      if (window.Shopify && typeof window.Shopify.shop === "string" && window.Shopify.shop.trim() !== "") {
        return window.Shopify.shop.trim(); // ex: yuacit-au.myshopify.com
      }
    } catch (e) {}
    return null;
  }

  function getFormEl() {
    return document.getElementById(FORM_ID);
  }

  function formToObject(formEl) {
    var fd = new FormData(formEl);
    var obj = {};
    fd.forEach(function (v, k) {
      if (obj[k] !== undefined) {
        if (!Array.isArray(obj[k])) obj[k] = [obj[k]];
        obj[k].push(v);
      } else {
        obj[k] = v;
      }
    });
    return obj;
  }

  // ✅ NOUVELLE REGLE: on envoie dès que le téléphone est "complet"
  // (nom/prénom optionnel; si présent il sera envoyé aussi)
  function shouldSend(formObj) {
    var phone = (formObj.phone || formObj.telephone || "").toString().trim();
    return !!phone;
  }

  // ✅ Validation téléphone "complet" (Tunisie strict : 8 chiffres ou +216XXXXXXXX)
  function normalizePhone(raw) {
    return (raw || "").toString().replace(/[^\d+]/g, "").trim();
  }
  function isPhoneComplete(raw) {
    var p = normalizePhone(raw);
    var digits = p.replace(/[^\d]/g, "");

    if (/^\+216\d{8}$/.test(p)) return true;   // +216XXXXXXXX
    if (/^\d{8}$/.test(digits)) return true;  // 8 chiffres
    return false;
  }

  function getPhoneFromData(data) {
    return (data && (data.phone || data.telephone || data.tel || data.mobile || "")) || "";
  }

  // ✅ Récupère les produits depuis le DOM du modal RSI
  function extractProductsFromModal() {
    var $form = window.jQuery ? window.jQuery("#" + FORM_ID) : null;
    if (!$form || !$form.length) return [];

    var items = [];

    $form.find("._rsi-modal-line-item").each(function () {
      var $it = window.jQuery(this);

      var variantId = $it.attr("data-line-item-variant-id") || null;

      // title
      var title = ($it.find("a._rsi-modal-line-item-title").text() || "").trim() || null;

      // quantity (le badge dans l'image)
      var qText = ($it.find("._rsi-modal-line-item-quantity").text() || "").trim();
      var quantity = parseInt(qText, 10);
      if (!quantity || quantity < 1) quantity = 1;

      // price
      var price = ($it.find("._rsi-modal-line-item-final-price").text() || "").trim() || null;

      // image
      var img = $it.find("img._rsi-modal-line-item-image").attr("src") || null;

      items.push({
        variant_id: variantId,
        product_id: null,          // pas dispo depuis ce DOM
        title: title,
        quantity: quantity,
        price: price,
        compare_at_price: null,    // pas dispo facilement
        image: img
      });
    });

    // Fallback si la section order summary est "not active"
    // -> on récupère au moins variantId/qty depuis les hidden inputs
    if (!items.length) {
      var formEl = getFormEl();
      if (formEl) {
        var data = formToObject(formEl);
        items = extractProductsFromHiddenInputs(data);
      }
    }

    return items;
  }

  // ✅ Fallback hidden inputs (variant_id + quantity)
  function extractProductsFromHiddenInputs(data) {
    var variants = {};
    var qtys = {};
    Object.keys(data || {}).forEach(function (k) {
      var v = data[k];
      if (typeof k !== "string") return;

      if (k.indexOf("item_variant_id[") === 0) {
        var inner = k.substring("item_variant_id[".length, k.length - 1);
        variants[inner] = v;
      }
      if (k.indexOf("item_quantity[") === 0) {
        var inner2 = k.substring("item_quantity[".length, k.length - 1);
        qtys[inner2] = v;
      }
    });

    var out = [];
    Object.keys(variants).forEach(function (innerKey) {
      var variantId = variants[innerKey];
      var q = parseInt(qtys[innerKey] || "1", 10);
      if (!q || q < 1) q = 1;

      out.push({
        variant_id: variantId ? String(variantId) : null,
        product_id: null,
        title: null,
        quantity: q,
        price: null,
        compare_at_price: null,
        image: null
      });
    });

    return out;
  }

  function buildPayload(formEl, reason) {
    var data = formToObject(formEl);

    return {
      shopify_domain: getShopifyDomain(),
      event: "form_abandoned",
      reason: reason || "phone_filled",
      occurred_at: new Date().toISOString(),
      page_url: window.location.href,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      form_id: FORM_ID,
      abandoned_order_id: data.abandoned_order_id || null,
      country_code: data.country_code || null,
      cart_token: data.cart_token || null,
      data: data,

      // ✅ produits enrichis depuis le DOM (ou fallback hidden inputs)
      products: extractProductsFromModal()
    };
  }

  // ✅ clé dédup persistante (shop + cart/abandoned + phone)
  function buildDedupKey(payload) {
    var shop = payload.shopify_domain || "unknown_shop";
    var cart = payload.cart_token || payload.abandoned_order_id || "no_cart";
    var phone = normalizePhone(getPhoneFromData(payload.data));
    return [LS_PREFIX, shop, cart, phone].join("|");
  }

  // ✅ Envoi fiable : sendBeacon puis fallback fetch no-cors (no preflight)
  function sendAbandon(payload) {
    var dkey = buildDedupKey(payload);

    // ✅ dédup session/page (par clé)
    if (sentKeys[dkey]) return;

    // ✅ dédup persistant
    if (safeLSGet(dkey) === "1") {
      sentKeys[dkey] = true;
      return;
    }

    // marquer envoyé
    sentKeys[dkey] = true;
    safeLSSet(dkey, "1");

    var body = JSON.stringify(payload);

    if (navigator.sendBeacon) {
      try {
        // text/plain pour éviter preflight
        var blob = new Blob([body], { type: "text/plain;charset=UTF-8" });
        navigator.sendBeacon(ENDPOINT, blob);
        return;
      } catch (e) {}
    }

    try {
      fetch(ENDPOINT, {
        method: "POST",
        mode: "no-cors",
        keepalive: true,
        headers: { "Content-Type": "text/plain;charset=UTF-8" },
        body: body
      }).catch(function () {});
    } catch (e) {}
  }

  function trySend(reason) {
    var formEl = getFormEl();
    if (!formEl) return;
    if (hasSubmitted) return;

    var payload = buildPayload(formEl, reason);

    var phone = getPhoneFromData(payload.data);
    if (!isPhoneComplete(phone)) return;     // ✅ téléphone complet obligatoire
    if (!shouldSend(payload.data)) return;   // ✅ téléphone existe

    sendAbandon(payload);
  }

  // ✅ écoute téléphone + debounce (évite spam pendant typing)
  var __phoneDebounceT = null;
  function hookPhoneWatcher() {
    var $ = window.jQuery;
    if (!$) return;

    var sel =
      "#" + FORM_ID + " input[name='phone'], " +
      "#" + FORM_ID + " input[name='telephone'], " +
      "#" + FORM_ID + " input[name='tel'], " +
      "#" + FORM_ID + " input[name='mobile'], " +
      "#" + FORM_ID + " input[type='tel']";

    $(document).on("input change blur", sel, function () {
      if (__phoneDebounceT) clearTimeout(__phoneDebounceT);
      __phoneDebounceT = setTimeout(function () {
        trySend("phone_filled");
      }, 400);
    });
  }

  function init() {
    // Marquer "submitted" si submit
    window.jQuery(document).on("submit", "#" + FORM_ID, function () {
      hasSubmitted = true;
    });

    // ✅ Nouveau comportement: dès que téléphone complet -> envoyer (1 fois par tel+panier)
    hookPhoneWatcher();

    // (Optionnel) garder click outside comme backup
    // window.jQuery(document).on("click", function (e) {
    //   var formEl = getFormEl();
    //   if (!formEl) return;
    //   var clickedInsideForm = window.jQuery(e.target).closest("#" + FORM_ID).length > 0;
    //   if (clickedInsideForm) return;
    //   trySend("global_click_outside_form");
    // });
  }

  function waitForJQAndInit() {
    var maxMs = 20000;
    var step = 200;
    var spent = 0;

    var t = setInterval(function () {
      if (typeof window.jQuery === "function") {
        clearInterval(t);
        init();
      } else {
        spent += step;
        if (spent >= maxMs) clearInterval(t);
      }
    }, step);
  }

  waitForJQAndInit();

  // ---------------------------
  // ✅ Méthodes de test console
  // ---------------------------
  window.__RSI_RESET_SESSION_SENT = function () {
    sentKeys = {};
    console.log("[RSI] sentKeys reset (session/page only)");
  };

  window.__RSI_SIMULATE_PHONE_FILLED = function () {
    trySend("test_simulate_phone_filled");
  };

  window.__RSI_CLEAR_DEDUP = function () {
    try {
      var keys = [];
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (k && k.indexOf(LS_PREFIX) === 0) keys.push(k);
      }
      keys.forEach(function (k) { localStorage.removeItem(k); });
      console.log("[RSI] cleared dedup keys:", keys.length);
    } catch (e) {
      console.log("[RSI] failed to clear dedup keys");
    }
  };
})();
